
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetogrishneshwercabservice() {



    const cardData =
    {
        keyword: 'Pune to Grishneshwar Cab Services',
        heading: 'S9 Travels: Pune to Grishneshwar Cab Services         ',
        headingDescription: 'S9 Travels offers comfortable, reliable, and affordable cab services from Pune to Grishneshwar. Whether you are heading to Grishneshwar for a religious pilgrimage or a peaceful retreat, we provide a smooth and hassle-free journey. Grishneshwar is located around 250 km from Pune, and the journey typically takes about 5 to 6 hours by road. With our well-maintained fleet and professional drivers, you can enjoy a comfortable ride with top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Grishneshwar with S9 Travels',

   "topPlaces": [
    {
      "title": "Grishneshwar Temple",
      "description": "Grishneshwar Temple is one of the 12 Jyotirlingas of India and holds immense religious significance. Devotees come from all over the country to seek blessings. The temple, dedicated to Lord Shiva, is known for its beautiful architecture and peaceful atmosphere."
    },
    {
      "title": "Ellora Caves",
      "description": "Located close to Grishneshwar, Ellora Caves is a UNESCO World Heritage site known for its ancient rock-cut temples and monasteries. The caves are a remarkable blend of Hindu, Buddhist, and Jain temples and are famous for their stunning sculptures and intricate carvings."
    },
    {
      "title": "Dnyaneshwar Temple",
      "description": "Situated in the town of Alandi, the Dnyaneshwar Temple is dedicated to the saint Dnyaneshwar. It holds great religious importance, especially for followers of the Bhakti movement. The temple is an important stop for those on a spiritual journey through Maharashtra."
    },
    {
      "title": "Daulatabad Fort",
      "description": "Daulatabad Fort, also known as Devgiri Fort, is a historical site near Grishneshwar. The fort is known for its strategic location and impressive architecture. The fort's imposing structure and intricate pathways make it an exciting place for history enthusiasts."
    },
    {
      "title": "Bibi Ka Maqbara",
      "description": "Located in Aurangabad, Bibi Ka Maqbara is often referred to as the 'Taj of the Deccan.' Built by the son of Aurangzeb in memory of his mother, the monument is a beautiful blend of Mughal and Deccan architectural styles."
    },
    {
      "title": "Aurangabad Caves",
      "description": "Aurangabad Caves, located on a hilltop, are a group of 12 Buddhist caves that date back to the 6th century. They are famous for their ancient sculptures and artwork that depict scenes from Buddhist mythology."
    },
    {
      "title": "Panchakki",
      "description": "Panchakki is an ancient water mill located in Aurangabad. It was designed to grind grain for the pilgrims visiting the city and is an interesting historical site with beautiful surroundings."
    },
    {
      "title": "Khuldabad",
      "description": "Khuldabad is a town near Grishneshwar known for its tranquil atmosphere and several historical monuments, including the tomb of the Sufi saint Zain-ud-Din. The town is a peaceful retreat for those looking to explore spiritual history and architecture."
    }
  ],

  "services": [
    {
      "name": "Book Pune to Grishneshwar Taxi",
      "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Grishneshwar Temple. Book your taxi with us for a smooth and hassle-free trip to one of the 12 Jyotirlingas in India."
    },
    {
      "name": "Book Pune to Grishneshwar Cab Booking",
      "description": "For a safe and enjoyable trip from Pune to Grishneshwar, S9 Travels provides easy cab booking options. Whether you need a one-way or round-trip journey, we ensure a comfortable and affordable ride."
    },
    {
      "name": "Pune to Grishneshwar One-Way Taxi",
      "description": "Looking for a one-way taxi from Pune to Grishneshwar? S9 Travels offers convenient one-way taxi services, ensuring that your journey is comfortable and stress-free. Travel directly to Grishneshwar without any hassle."
    },
    {
      "name": "Pune to Grishneshwar Round Trip",
      "description": "S9 Travels provides round-trip taxi services from Pune to Grishneshwar Temple, ensuring a safe and timely journey. Our professional drivers and well-maintained vehicles offer a comfortable ride for your return trip as well."
    },
    {
      "name": "Pune to Grishneshwar Taxi Fare",
      "description": "S9 Travels offers affordable and transparent taxi fares for your journey from Pune to Grishneshwar. We ensure that you are aware of the cost upfront with no hidden charges. Get in touch for an accurate fare estimate for your trip."
    },
    {
      "name": "Pune to Grishneshwar Car Rental",
      "description": "Looking for a car rental service for your trip to Grishneshwar from Pune? S9 Travels offers a variety of rental options to suit your needs. Choose from well-maintained vehicles and enjoy a comfortable, flexible journey."
    },
    {
      "name": "Pune to Grishneshwar Luxury Taxi",
      "description": "Travel in style with our luxury taxi service from Pune to Grishneshwar Temple. Enjoy a premium experience with added comfort, space, and top-notch amenities for a luxurious pilgrimage experience."
    },
    {
      "name": "Pune to Grishneshwar Efficient Taxi",
      "description": "S9 Travels offers Efficient Taxi services for those looking for a budget-friendly option for the journey to Grishneshwar Temple. Share the ride with others and enjoy a comfortable journey at a lower cost."
    },
    {
      "name": "Affordable Pune to Grishneshwar Taxi",
      "description": "If you’re looking for an affordable taxi from Pune to Grishneshwar, S9 Travels offers competitive pricing without compromising on comfort or service quality. We ensure that you get the best value for your money."
    },
    {
      "name": "Grishneshwar Temple Taxi from Pune",
      "description": "S9 Travels specializes in Grishneshwar Temple taxi services from Pune. Book a reliable and comfortable taxi for a hassle-free trip to one of the sacred 12 Jyotirlingas."
    },
    {
      "name": "Grishneshwar Temple Car Hire",
      "description": "Hire a car for your trip to Grishneshwar Temple with S9 Travels. We offer well-maintained vehicles and professional drivers to make your journey comfortable, convenient, and safe."
    },
    {
      "name": "Pune to Grishneshwar Private Cab",
      "description": "For a personalized and comfortable journey, book a private cab from Pune to Grishneshwar Temple. S9 Travels offers private cabs for a peaceful and customized experience on your pilgrimage."
    },
    {
      "name": "Grishneshwar Taxi Service from Pune",
      "description": "S9 Travels provides reliable and efficient Grishneshwar taxi services from Pune. Whether you’re traveling for a spiritual journey or simply visiting the temple, our professional drivers and quality vehicles ensure a comfortable trip."
    },
    {
      "name": "Book Grishneshwar Temple Tour",
      "description": "Book your Grishneshwar Temple tour with S9 Travels for a seamless and memorable pilgrimage experience. We provide taxi services to and from the temple, ensuring that your visit is smooth and enjoyable."
    }
  ],


"tableData": [
  ["Book Pune To Grishneshwar Taxi", "Book Pune To Grishneshwar Cab Booking"],
  ["Pune To Grishneshwar One-Way Taxi", "Pune To Grishneshwar Round Trip"],
  ["Pune To Grishneshwar Taxi Fare", "Pune To Grishneshwar Car Rental"],
  ["Pune To Grishneshwar Luxury Taxi", "Pune To Grishneshwar Efficient Taxi"],
  ["Affordable Pune to Grishneshwar Taxi", "Grishneshwar Temple Taxi from Pune"],
  ["Grishneshwar Temple Car Hire", "Pune to Grishneshwar Private Cab"],
  ["Grishneshwar Taxi Service from Pune", "Book Grishneshwar Temple Tour"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of punctuality for your visit to Grishneshwar. Whether you're going for a peaceful spiritual trip or a quick visit, our drivers ensure timely pickups and drop-offs, making your trip hassle-free and comfortable."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, for your journey from Pune to Grishneshwar. With spacious seating, air conditioning, and ample luggage space, our vehicles guarantee a comfortable and relaxing ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and familiar with the route to Grishneshwar. They prioritize your safety and comfort, ensuring a smooth and enjoyable journey. They are courteous, professional, and knowledgeable about the best routes for your trip."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your trip from Pune to Grishneshwar. We provide a clear breakdown of costs with no hidden charges, so you know exactly what to expect. Our transparent pricing ensures a stress-free experience."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking, ensuring a safe and secure journey from Pune to Grishneshwar. You can relax knowing that we have taken every step to ensure your safety."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you’re planning an early morning trip or a late-night return, S9 Travels is available 24/7 to meet your needs. Our customer service team is always ready to assist with bookings or any other inquiries you may have."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Grishneshwar cab with S9 Travels is simple and convenient. You can book easily through our website or mobile app, or contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We understand that each traveler has unique needs. Whether you’re visiting Grishneshwar for spiritual reasons or leisure, we offer customized travel packages that suit your preferences. Let us know your requirements, and we’ll make your journey special."
  }
]
















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Grishneshwar cab with S9 Travels?',
            answer: 'You can book a cab online through our website or app. Alternatively, you can contact our customer service team for personalized assistance with your booking.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Grishneshwar trip?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained to provide you with the utmost comfort and safety during your journey.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Grishneshwar?',
            answer: 'Yes, all our drivers are highly skilled and experienced in long-distance travel. They know the best routes to Grishneshwar and ensure a smooth and safe journey.',
          },
          {
            question: 'How do I pay for my Pune to Grishneshwar cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments through our app, making it convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round-trip from Pune to Grishneshwar?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll take care of the rest, ensuring a comfortable and stress-free return journey.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront before your trip, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Grishneshwar?',
            answer: 'Yes, we offer sightseeing services in Grishneshwar. Explore the famous Grishneshwar Temple and other nearby attractions with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Grishneshwar cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or special requirements, please inform us at the time of booking, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel to Grishneshwar?',
            answer: 'Yes, we offer corporate travel services, including group trips or business-related visits to Grishneshwar. We ensure professional service for all corporate trips.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Grishneshwar journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth trip to Grishneshwar.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Ramesh Kumar',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for a visit to Grishneshwar. The vehicle was clean and comfortable, and the driver was friendly and professional. The trip was smooth, and I felt safe throughout. Highly recommend!”',
        },
        {
          name: 'Mrs. Neha Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family took a trip from Pune to Grishneshwar with S9 Travels. The vehicle was spacious and comfortable, and the driver was courteous and knowledgeable. A very pleasant and stress-free journey!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Grishneshwar Cab Services",
        "description": "Book Pune to Grishneshwar cab services with S9 Travels. Whether you need a one-way taxi, round-trip, or luxury cab, we offer affordable and comfortable transportation to Grishneshwar Temple. Explore our car rental services, private cabs, and Efficient Taxis for your journey from Pune to Grishneshwar.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      


    return (
        <div>
          <Helmet>
        <title>Pune To Grishneshwar Cab Services | Affordable Taxi & Car Rentals | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Grishneshwar taxi services, one-way, round-trip, luxury taxis, Efficient Taxis, and car rentals with S9 Travels. Get the best fares for your Grishneshwar Temple tour and enjoy a comfortable, safe, and convenient ride from Pune." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/20.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogrishneshwercabservice;